import Vue from 'vue';
import VueSimpleSpinner from 'vue-simple-spinner';
import HttpMixin from '@/mixins/HttpMixin';
import {HTTP} from '@/utils/httpCommonUtil';

export default Vue.component('past-payments', {
  name: 'PastPayments',
  props: {
    'providerId': { type: [String, Number] }
  },
  components: {
    VueSimpleSpinner
  },
  mixins: [ HttpMixin ],
  data () {
    return {
      cardExpanded: false,
      pastPayments: []
    };
  },
  async created () {
    await this.expandCard();
  },
  methods: {
    async expandCard() {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.fetch();
      }
    },
    async fetch() {
      const data = await (this as any).httpGet(`/providers/${this.providerId}/payments?isPast=true`, 'An error occurred retrieving Past Payments.');
      if (data) {
        this.pastPayments = data;
      }
    },
    async openAttachment (payment: any) {
      try {
        const response = await HTTP.get('/api/s3/signed-url/get-provider?s3key=' + payment.s3Key);
        if (!response.data || !response.data.data) {
          throw new Error("Error getting attachment.");
        }
        window.open(response.data.data, '_blank');
      } catch (err) {
        console.error(err);
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error',
          text: 'An error occurred opening Paystub.'
        });
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/payments/cards/pastPayments/PastPayments.ts